module.exports = "<div class=\"option ripple\" (click)=\"go()\">\n  <div class=\"option-icon\" [ngClass]=\"{'option-selected': selected}\">\n    <i class=\"icon-{{ icon }}\"></i>\n  </div>\n  <div class=\"option-label\">\n    {{ label }}\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/core/mainbar-option/mainbar-option.component.html
// module id = 1095
// module chunks = 0